// @ai-generated 2026-07-28T15:01:24+00:00 by niklas.eicker@tngtech.com using Claude Opus 5
import {
    type ApiRequisition,
    EnumRequisitionStatus,
    getPortalRequisitionOriginLabel,
    getPortalRequisitionStatusLabel,
    getPortalRequisitionStatusVariant,
} from '@Model';
import {
    Badge,
    type Column,
    type LinkableField,
    renderDateTime,
    ValueWithBadges,
} from '@synqo/frontend-component-library';
import { AddressLines } from '@Components/AddressLines';
import { RequisitionActionChip } from '@Components/RequisitionActionChip';
import { getRelativeDayLabel } from '@utils/relativeDayLabel';
import { formatRequisitionDesiredDate, formatRequisitionMaterial } from '@utils/requisitionDisplay';

function formatDate(value: unknown): string | undefined {
    return value ? renderDateTime(value as string, 'date') : undefined;
}

/**
 * Customer wording and a single desired-date column; the ERP keeps {@link requisitionColumns}.
 */
export function portalRequisitionColumns(
    materialOf: (service: LinkableField | undefined) => string,
): Readonly<Column<ApiRequisition>>[] {
    return [
        {
            name: 'number',
            label: 'Bestellnummer',
            renderCell: ({ rowData }) => {
                const originLabel = getPortalRequisitionOriginLabel(rowData.origin);

                return (
                    <ValueWithBadges value={rowData.number}>
                        <RequisitionActionChip requisition={rowData} />
                        {originLabel && (
                            <Badge variant="accent" size="xxs">
                                {originLabel}
                            </Badge>
                        )}
                    </ValueWithBadges>
                );
            },
        },
        {
            name: 'site.display_string',
            label: 'Leistungsort',
            disableColumnFilter: true,
            renderCell: ({ rowData }) => <AddressLines location={rowData.site} />,
        },
        {
            name: 'positions',
            label: 'Material',
            disableColumnSort: true,
            disableColumnFilter: true,
            renderCell: ({ rowData }) => <>{formatRequisitionMaterial(rowData, materialOf) || '—'}</>,
        },
        {
            name: 'created_at',
            label: 'Bestellt am',
            type: 'datetime',
            renderCell: ({ cellData }) => <>{formatDate(cellData) ?? '—'}</>,
        },
        {
            name: 'date_from',
            label: 'Wunschtermin',
            type: 'date',
            filterVariant: 'day-range',
            renderCell: ({ rowData }) => {
                const relativeLabel = getRelativeDayLabel(rowData.date_from);

                return (
                    <ValueWithBadges value={formatRequisitionDesiredDate(rowData)}>
                        {relativeLabel && (
                            <Badge variant="primary" size="xxs">
                                {relativeLabel}
                            </Badge>
                        )}
                    </ValueWithBadges>
                );
            },
        },
        {
            name: 'process_state',
            label: 'Status',
            renderCell: ({ cellData }) => (
                <Badge withDot variant={getPortalRequisitionStatusVariant(cellData as EnumRequisitionStatus)}>
                    {getPortalRequisitionStatusLabel(cellData as EnumRequisitionStatus)}
                </Badge>
            ),
        },
    ];
}
